import { combineReducers } from "redux";
import tabsReducer from "./tabs.reducers";
import mattersReducer from "./matters.reducer";
import currentuserReducer from "./currentuser.reducer";
import PostingsDetails from "./postings.reducer";
import TransactionPeriodReducer from "./transactionperiod.reducer";
import AutoLoginReducer from "./autologin.reducer";
import FilesDownload from "./filesDownlaod.reducer";
import contactsReducer from "./contacts.reducer";
import timeReducer from "./time.reducer";
import billReducer from "./bill.reducer";
import ledgerLinks from "./ledgerlinks.reducer";
import chitPostingReducer from "./chitPosting.reducer";
import ProfitCostTemplate from "./fixedFeeHeader.reducer";
import CommonReducer from "./common.reducer";
import clientsReducer from "./clients.reducer";
import BillingRequestsReducer from "./billingRequests.reducer";
import ctoSweepReducer from "./ctosweep.reducer";
import { branchReducer } from "services/branchService";
import { vatReducer } from "services/vatService";
import { currentUserReducer } from "services/currentUserService";
import { currentUserSettingsReducer } from "services/userSettingsService";
import { usersReducer } from "services/userService";
import { departmentReducer } from "services/departmentService";
import { workTypeReducer } from "services/workTypeService";
import { supplierReducer } from "services/supplierService";
import { companyReducer as CompanyServiceReducer } from "services/companyService";
import { activityTypeReducer } from "services/activityTypeService";
import { timeTypeReducer } from "services/timeTypeService";
import { dashboardReducer } from "services/dashboardService";
import { applicationSettingsReducer } from "services/applicationSettingsService";
import { nominalsReducer } from "services/nominalsService";
import { currencyReducer } from "services/currencyService";
import { applicationReducer } from "services/applicationService";
import { docTypeReducer } from "services/docTypeService";
import dialogReducer from "reducers/errorDialogSlice";
import { referrerReducer } from "services/referrersService";
import { sourceReducer } from "services/sourcesService";

const rootReducer = combineReducers({
  tabsData: tabsReducer,
  mattersList: mattersReducer,
  contactsList: contactsReducer,
  nominals: nominalsReducer,
  suppliers: supplierReducer,
  currentuser: currentuserReducer,
  currentUser: currentUserReducer,
  currentUserSettings: currentUserSettingsReducer,
  users: usersReducer,
  company: CompanyServiceReducer,
  time: timeReducer,
  branches: branchReducer,
  vats: vatReducer,
  currencies: currencyReducer,
  postingsdocs: PostingsDetails,
  transactionperiods: TransactionPeriodReducer,
  loginOn: AutoLoginReducer,
  filesDownload: FilesDownload,
  billsMatterData: billReducer,
  ledgerLinks: ledgerLinks,
  chitPosting: chitPostingReducer,
  profitCostTemplate: ProfitCostTemplate,
  common: CommonReducer,
  clients: clientsReducer,
  workTypes: workTypeReducer,
  departments: departmentReducer,
  dashboard: dashboardReducer,
  referrers: referrerReducer,
  sources: sourceReducer,
  docTypes: docTypeReducer,
  billingRequests: BillingRequestsReducer,
  ctoSweep: ctoSweepReducer,
  activityTypes: activityTypeReducer,
  timeTypes: timeTypeReducer,
  applicationSettings: applicationSettingsReducer,
  applicationsData: applicationReducer,
  errorDialog: dialogReducer,
});

export default rootReducer;
